import { FC } from 'react';
import { useAtomValue } from 'jotai';
import CreatorTutorials from 'src/components/Creator/CreatorOnboarding/Tutorials';
import CreatorWelcomeModal from 'src/components/Creator/CreatorOnboarding/WelcomeModal';
import { CreatorOnboardingStep, creatorOnboardingStepAtom } from 'src/stores/creator/atom';
import CreatorGuidelineModal from './CreatorGuidelineModal';
const CreatorOnboarding: FC = () => {
  const currentStep = useAtomValue(creatorOnboardingStepAtom);
  switch (currentStep) {
    case CreatorOnboardingStep.Welcome:
      return <CreatorWelcomeModal />;
    case CreatorOnboardingStep.Guideline:
      return <CreatorGuidelineModal />;
    case CreatorOnboardingStep.Tutorials:
      return <CreatorTutorials />;
    default:
      return null;
  }
};
export default CreatorOnboarding;